import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './underline-scroll.css';

const clamp = value => Math.max(0, Math.min(1, value));
const selectors = '.ink-underline, .fokeev-hero h1 span, .blog-heading h1 span, .blog-hero h1 span, .catalog-heading h1 .text-transparent, .course-catalog-text, .hero-stat-rating, .fokeev-handwritten, .blog-hero-handnote, .practice-note em';

export const UnderlineScroll = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const targets = [...document.querySelectorAll(selectors)].map(element => ({
      element,
      scene: element.closest('[data-scroll-scene]'),
      firstHeading: Boolean(element.closest('.fokeev-hero h1, .course-paper-hero h1, .blog-hero h1, .blog-heading h1, .catalog-heading h1')),
      last: null,
    }));
    let frame = 0, disposed = false;
    const draw = () => {
      frame = 0;
      const height = window.innerHeight;
      // Read positions together before writing styles, avoiding layout churn.
      const progress = targets.map(({ element, scene, firstHeading }) => {
        if (preference.matches || element.matches(':focus-within') || element.closest('a:focus-visible')) return 1;
        if (scene?.classList.contains('format-scroll-active')) {
          const value = scene.contains(document.activeElement) ? 1 : clamp((88 - scene.getBoundingClientRect().top) / (scene.offsetHeight - (height - 88)));
          return element.closest('.practice-note') ? clamp((value - .10) / .23) : clamp((value - .69) / .16);
        }
        if (firstHeading) return 1;
        return clamp((height * .90 - element.getBoundingClientRect().top) / (height * .36));
      });
      targets.forEach((target, index) => {
        target.element.classList.toggle('scroll-underline', !preference.matches);
        const value = progress[index].toFixed(4);
        if (target.last === value) return;
        target.last = value;
        target.element.style.setProperty('--underline-progress', `${Number(value) * 100}%`);
      });
    };
    const schedule = () => { if (!disposed && !frame) frame = requestAnimationFrame(draw); };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    preference.addEventListener('change', schedule);
    document.fonts?.ready.then(schedule);
    draw();
    return () => {
      disposed = true;
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      document.removeEventListener('focusin', schedule);
      document.removeEventListener('focusout', schedule);
      preference.removeEventListener('change', schedule);
      targets.forEach(({ element }) => {
        element.classList.remove('scroll-underline');
        element.style.removeProperty('--underline-progress');
      });
    };
  }, [pathname]);
  return null;
};
